import { jwtDecode } from "jwt-decode";
import { PublicClientApplication } from '@azure/msal-browser';
import { ISDLClientID } from "../isdlData/isdlData";

// MSAL configuration with cache settings for persistence (helps on iOS)
const msalConfig = {
    auth: {
      clientId: ISDLClientID(),
      authority: "https://login.microsoftonline.com/7911194b-cd2e-47e4-9b1b-bd1ad29a8383",
      // Use a fully qualified URL that is registered in Azure AD.
      redirectUri: window.location.href,
    },
    cache: {
      cacheLocation: "localStorage", // Persist cache in local storage
      storeAuthStateInCookie: true,   // Recommended for iOS or IE
    }
  };

export const msalInstance = new PublicClientApplication(msalConfig);

export const isTokenValid = (token) => {
    try {
      const decoded = jwtDecode(token);
      // decoded.exp is in seconds; convert to milliseconds
      if (decoded.exp * 1000 < Date.now()) {
        return false; // Token has expired
      }
      return true;
    } catch (error) {
      console.error("Token decoding failed:", error);
      return false;
    }
  };

export const refreshTokenSilently = async () => {
    const cachedAccounts = msalInstance.getAllAccounts();
    if (cachedAccounts && cachedAccounts.length > 0) {
    msalInstance.setActiveAccount(cachedAccounts[0]);

    try {
        const silentTokenResponse = await msalInstance.acquireTokenSilent({
        account: cachedAccounts[0],
        scopes: [`${ISDLClientID()}/.default`],
        });
        let authToken = silentTokenResponse.accessToken;
        sessionStorage.setItem("authToken", authToken);
        return authToken;
    } catch (tokenError) {
        console.error("Silent token acquisition failed:", tokenError);
        return null;
    }
    } else {
        console.error("No cached account found for silent refresh.");
        return null;
    }
}